<div class="jumbotron animated fadeIn fast">
  <div class="container-fluid">
    <label class="title">Últimas solicitudes cargadas</label>
    <app-loading *ngIf="loading"></app-loading>
    <app-no-results
      *ngIf="!loading && requests?.length === 0"
      [data]="constants.alerts.noResults.emptySearch"
    ></app-no-results>
    <app-no-results *ngIf="!loading && error" [data]="error"></app-no-results>
    <div class="table-container">
      <table
        *ngIf="!loading && requests?.length > 0"
        class="table table-striped animated fadeIn"
      >
        <tbody>
          <tr *ngFor="let request of requests | paginate: config">
            <td class="col-md-3 first">
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">N° de Solicitud</span>
                </div>
                <div class="col col-md-8 text-left">
                  <b class="value">{{ request.number }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-4">
                  <span class="property"
                    >Tipo de Solicitud</span
                  >
                </div>
                <div class="col col-md-8 text-left">
                  <b class="value">{{ request.type.name }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-3">
              <div class="row">
                <div class="col col-md-3">
                  <span class="property">Moneda</span>
                </div>
                <div class="col col-md-9">
                  <b class="value">{{ request.currency }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-3">
                  <span class="property">Monto</span>
                </div>
                <div class="col col-md-9 d-inline-table">
                    <b class="value">{{
                      request.amount | currency:'':'' | customCurrency:request.currency
                    }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-3">
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Estado</span>
                </div>
                <div class="col col-md-8">
                    <b class="value">{{
                      request.state.getName() | titlecase
                    }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-4">
                  <span class="property">Responsable</span>
                </div>
                <div class="col col-md-8 d-inline-table">
                  <b class="value">{{ request.responsible | titlecase }}</b>
                </div>
              </div>
            </td>
            <td class="col-md-2">
              <div class="row">
                <div class="col col-md-6">
                  <span class="property"
                    >Fecha de carga</span
                  >
                </div>
                <div class="col col-md-6">
                    <b class="value">{{
                      request.date | date: "dd/MM/yyyy"
                    }}</b>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-6"></div>
                <div class="col col-md-6">
                  <span class="property"
                    ><a
                      class="lighter-green show-request"
                      [routerLink]="['/pages/request-detail', 'history', request.number]"
                    >
                      <b>Ver solicitud</b></a
                    ></span
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
